export default {
  lang: 'English',
  title: 'Differences Ranch Journey',

  dark_theme: 'Dark theme',

  sign_in: 'Sign in',
  sign_up: 'Sign up',
  sign_out: 'Sign Out',
  recover: 'Recover password',
  resend: 'Resend confirmation',
  reset: 'Reset password',

  yes: 'Yes',
  no: 'No',

  dev: 'Dev version',
  release: 'Release version',
  play: 'Play',

  xlerrors: {
    //
  },

  notifications: {
    check_email: 'Please check your email',
    password_changed: 'Password changed, please sign in now'
  },

  labels: {
    email: 'E-mail',
    password: 'Password',
    new_password: 'New password',
    promo: 'Receive promo emails',
    agree_to: 'I agree to the',
    agree_to_tos: 'Terms of Service and Privacy Policy',
    tos: 'Terms of Service and Privacy Policy'
  },

  validations: {
    email_required: 'E-mail is required',
    email_invalid: 'E-mail must be valid',

    password_required: 'Password is required',
    password_invalid: 'Password must be at least 6 characters',

    agreement_invalid: 'You must agree to continue'
  }

  // get_access_contact: 'To get access to servers, please contact administrator.',
  //
  // id: '#',
  // api_type: 'Media',
  // api_uid: 'UID',
  // type: 'Type',
  // status: 'Status',
  // param: 'Param',
  // value: 'Value',
  // name: 'Name',
  // avatar: 'Avatar',
  // data: 'Data',
  // created_at: 'Created at',
  // updated_at: 'Updated at',
  //
  // bases: {
  //   release: 'Release',
  //   development: 'Dev',
  //   test: 'Test'
  // },
  //
  // api_types: {
  //   '-1': 'Any network',
  //
  //   1: 'OK',
  //   2: 'VK',
  //   3: 'FB',
  //   4: 'MM',
  //   5: 'WizQ',
  //   6: 'Frype',
  //   7: 'FS',
  //   8: 'GM',
  //   9: 'NK',
  //
  //   10: 'iOS',
  //   11: 'Android',
  //   12: 'Amazon',
  //   13: 'MS Store',
  //
  //   23: 'FB IG',
  //   24: 'Xsolla',
  //
  //   99: 'Merged profile',
  //
  //   100: 'WEB DEV',
  //
  //   203: 'FB Login'
  // },
  //
  // validation: {
  //   api_type_required: 'Media is required',
  //   api_uid_required: 'UID is required',
  //   type_required: 'Type is required',
  //   name_required: 'Name is required'
  // }
}
